/**
 * SMYLE PDP in-page anchors (FAQ CTA, etc.).
 * Clears sticky top bar + floating nav so the target is not covered.
 * Avoids a second “overshoot” scroll from hash / section-anchor-scroll.js.
 */
(function () {
  if (window.__pbSmyleAnchorScroll) return;
  window.__pbSmyleAnchorScroll = true;

  var EXTRA_GAP = 20;
  var ignoreHashScrollUntil = 0;

  function stickyOffset() {
    var bottom = 0;
    var nodes = document.querySelectorAll(
      '.pb-unified-top-bar, .pb-unified-nav__fixed, sticky-header, .shopify-section-header-sticky, header-component'
    );
    for (var i = 0; i < nodes.length; i++) {
      var rect = nodes[i].getBoundingClientRect();
      if (rect.height > 0 && rect.bottom > bottom) bottom = rect.bottom;
    }
    if (bottom < 40) {
      bottom = window.matchMedia('(max-width: 992px)').matches ? 110 : 146;
    }
    return Math.ceil(bottom) + EXTRA_GAP;
  }

  function syncCssVar() {
    var offset = stickyOffset() + 'px';
    document.documentElement.style.setProperty('--pb-smyle-anchor-offset', offset);
    document.documentElement.style.setProperty('--pb-smyle-anchor-offset-mobile', offset);
  }

  function scrollToId(id, behavior) {
    var target = document.getElementById(id);
    if (!target) return false;
    syncCssVar();
    var top = target.getBoundingClientRect().top + window.scrollY - stickyOffset();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: behavior || (reduce ? 'auto' : 'smooth'),
    });
    return true;
  }

  function parseHashId(href) {
    if (!href) return null;
    var i = href.indexOf('#');
    if (i === -1) return null;
    try {
      return decodeURIComponent(href.slice(i + 1).trim()) || null;
    } catch (e) {
      return href.slice(i + 1).trim() || null;
    }
  }

  /**
   * Update the URL hash without the browser jumping to the element
   * (which would fight our offset scroll and “scroll more” after we land).
   */
  function setHashWithoutNativeScroll(id) {
    var target = document.getElementById(id);
    ignoreHashScrollUntil = Date.now() + 1200;
    window.__pbSmyleIgnoreHashScrollUntil = ignoreHashScrollUntil;

    if (target) {
      target.removeAttribute('id');
      history.pushState(null, '', window.location.pathname + window.location.search + '#' + encodeURIComponent(id));
      target.id = id;
    } else {
      history.pushState(null, '', window.location.pathname + window.location.search + '#' + encodeURIComponent(id));
    }
  }

  function onClick(event) {
    if (!(event.target instanceof Element)) return;
    var link = event.target.closest('a[data-pb-smyle-faq-cta], .pb-smyle-faq-cta a[href*="#"]');
    if (!link) return;

    var id = parseHashId(link.getAttribute('href'));
    if (!id || !document.getElementById(id)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    setHashWithoutNativeScroll(id);
    scrollToId(id);
  }

  function onHash() {
    if (Date.now() < ignoreHashScrollUntil) return;
    if (!document.body || !document.body.classList.contains('pb-smyle-pdp')) return;
    var id = parseHashId(window.location.hash);
    if (!id || !document.getElementById(id)) return;
    // Only correct load/external hash navigation — not our own CTA clicks
    scrollToId(id, 'auto');
  }

  // Capture on window so we run before document listeners (section-anchor-scroll)
  window.addEventListener('click', onClick, true);
  window.addEventListener('resize', syncCssVar, { passive: true });
  window.addEventListener('hashchange', onHash);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCssVar);
  } else {
    syncCssVar();
  }
})();
